import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  templateNameLabel: {
    id: 'QzBo3r',
    defaultMessage: 'Template Name',
    description: 'Label for the template name input field',
  },
  pageSizeLabel: {
    id: '89qzIG',
    defaultMessage: 'Size',
    description: 'Label for the size dropdown',
  },
  orientationLabel: {
    id: 'qe1t7M',
    defaultMessage: 'Orientation',
    description: 'Label for the orientation dropdown',
  },
  saveButton: {
    id: 'M9dS+j',
    defaultMessage: 'Save',
    description: 'Label for the save button in the HTML editor drawer',
  },
  cancelButton: {
    id: '6Zl9BB',
    defaultMessage: 'Cancel',
    description: 'Label for the cancel button in the HTML editor drawer',
  },
  orientationPortrait: {
    id: 'Y7Nb7I',
    defaultMessage: 'Portrait',
    description: 'Portrait orientation option in the HTML editor drawer',
  },
  orientationLandscape: {
    id: 'bLRN6r',
    defaultMessage: 'Landscape',
    description: 'Landscape orientation option in the HTML editor drawer',
  },
  templateNameMinLength: {
    id: 'p+LzY2',
    defaultMessage: 'Template name must be at least 3 characters',
    description: 'Error message when template name is too short',
  },
  saveTemplateSuccessTitle: {
    id: 'cP+Q2W',
    defaultMessage: 'Template Saved',
    description: 'Success notification title when template is saved',
  },
  saveTemplateSuccessContent: {
    id: '7iDCYS',
    defaultMessage: 'Your template has been saved successfully.',
    description: 'Success notification content when template is saved',
  },
  saveTemplateErrorTitle: {
    id: 'DKS8ov',
    defaultMessage: 'Failed to Save Template',
    description: 'Error notification title when saving template fails',
  },
  saveTemplateErrorContent: {
    id: 'lq5BPm',
    defaultMessage: 'Unable to save the template. Please try again.',
    description: 'Error notification content when saving template fails',
  },
  formatButton: {
    id: 'X6RiMU',
    defaultMessage: 'Format',
    description: 'Label for the format button in the HTML editor drawer',
  },
  formatButtonAriaLabel: {
    id: 'KoOKcA',
    defaultMessage: 'Format HTML',
    description: 'Aria label for the format button in the HTML editor drawer',
  },
  formatButtonTitle: {
    id: 'dnkaT4',
    defaultMessage: 'Format HTML (Ctrl+Shift+F)',
    description: 'Tooltip for the format button showing the keyboard shortcut',
  },
  collapseSidebar: {
    id: 'qT91gL',
    defaultMessage: 'Collapse sidebar',
    description: 'Aria label for the button that collapses the field replacement sidebar',
  },
  expandSidebar: {
    id: 'luz4ub',
    defaultMessage: 'Expand sidebar',
    description: 'Aria label for the button that expands the field replacement sidebar',
  },
  insertFieldButton: {
    id: 'sSPd/U',
    defaultMessage: 'Insert Field',
    description: 'Label for the button that toggles the field replacement sidebar in the HTML editor toolbar',
  },
  darkModeToggle: {
    id: 'a9AOPp',
    defaultMessage: 'Dark mode',
    description: 'Label for the dark mode toggle switch in the HTML code editor toolbar',
  },
});
